<template>
  <div class="download-app-wrap" @click="download">
    <div class="btn">下载App</div>
  </div>
</template>

<script>
export default {
  name: "download-app",
  data() {
    return {};
  },
  methods: {
    download() {
      const a = document.createElement("a");
      a.href =
        "https://car-manager.oss-cn-hangzhou.aliyuncs.com/app-v1-release-1.1.apk";
      a.download =
        "https://car-manager.oss-cn-hangzhou.aliyuncs.com/app-v1-release-1.1.apk";
      a.click();
      console.log("download");
      //   window.open('')
    },
  },
};
</script>

<style scoped>
.download-app-wrap {
  position: fixed;
  top: calc(50% + 120px);
  right: 0;
  cursor: pointer;
  align-items: center;
  height: 70px;
  z-index: 99;
}
.btn {
  position: relative;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  height: 40px;
  width: 40px;
  padding: 5px;
  border-radius: 25px;
  background-color: #1c96d4;
  margin-left: 5px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/page/common/DownloadApp.vue